<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : materials.id ? '编辑' : '新建'"
      width="1300px"
      top="10vh"
      class="materialEdit"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="materials"
        :rules="ruleValidate"
        class="form"
        label-width="100px"
    >
      <div class="editTitle">物料信息</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="物料编号">
            <el-input v-model="materials.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料描述" prop="name">
            <el-input v-model="materials.name" placeholder="请输入物料描述" :disabled="!!materials.id"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料状态" prop="status">
            <el-select v-model="materials.status" readonly placeholder="物料状态" :disabled="!!materials.id">
              <el-option label="启用" :value="10"/>
              <el-option label="禁用" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="规格规格">
            <el-input v-model="materials.zmyxh" placeholder="请输入规格规格" :disabled="!!materials.id"/>
          </el-form-item>
        </el-col>
        <el-row>
          <el-col :span="6">
            <el-form-item label="物料组">
              <el-input v-model="materials.materialGroupNO" placeholder="请输入物料组" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="MRP控制者">
              <el-input v-model="materials.mrpController" placeholder="请输入MRP控制者" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="旧物料号">
              <el-input v-model="materials.mappingMaterialNo" placeholder="请输入旧物料号" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单位" prop="unit">
              <el-input v-model="materials.unit" placeholder="请选择物料单位" readonly :disabled="!!materials.id">
                <el-button slot="append" icon="el-icon-search" :disabled="!!materials.id" @click="$refs.unitSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="软著信息">
              <el-input v-model="materials.softInfo" placeholder="请输入软著信息" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="厂家型号">
              <el-input v-model="materials.manufacturerModel" placeholder="请输入厂家型号" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品分配">
              <el-input v-model="materials.productDistribution" placeholder="请输入产品分配" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品层次">
              <el-input v-model="materials.productLayer" placeholder="请输入产品层次" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="采购类型">
              <el-input v-model="materials.procurementType" placeholder="请输入采购类型" :disabled="!!materials.id"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="营销定级">
              <el-select v-model="materials.marketingLevel" clearable placeholder="请选择营销定级">
                <el-option label="S级战略主推" value="S级战略主推"/>
                <el-option label="A级常规主推" value="A级常规主推"/>
                <el-option label="B级限销维持" value="B级限销维持"/>
                <el-option label="C级禁售退市" value="C级禁售退市"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退市管理">
              <el-select v-model="materials.delistStatus" clearable placeholder="请选择退市管理">
                <el-option label="在售" :value="10"/>
                <el-option label="待退市" :value="20"/>
                <el-option label="消耗库存" :value="30"/>
                <el-option label="停售" :value="40"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标准交期">
              <el-input-number v-model="materials.standardDeliveryTime" :min="0" :controls="false" placeholder="请输入标准交期(天)"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="机种代码">
              <el-input v-model="materials.productCode" placeholder="请输入机种代码"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="净重">
              <el-input v-model="materials.netWeight" placeholder="请输入净重"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="毛重">
              <el-input v-model="materials.grossWeight" placeholder="请输入毛重"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产成品条码">
              <el-select v-model="materials.needSerialNo">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发货成品条码">
              <el-select v-model="materials.deliverySerialNo">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="配件包">
              <el-select v-model="materials.peiJianPack">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="舍入值">
              <el-input-number v-model="materials.roundedValue"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最小包装量">
              <el-input-number v-model="materials.minPackQty"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">物料照片</div>
        <div style="display: flex;">
          <vm-upload-file
              v-if="limits.uploadAuth"
              v-model="uploadImg.pictureUrl"
              filename.sync=""
              accept=".jpg,.png"
              @update:filename="uploadSuccess"
          />
        </div>
        <el-table class="tableBox" :data="materials.accessoryList" border>
          <el-table-column label="名称" prop="fileName" width="200"/>
          <el-table-column label="图片" prop="center" width="200">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="note"/>
          <el-table-column label="附件类型" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.itemType === 16">物料照片</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <down-load-file :file-key="scope.row.filePath"/>
              <el-button type="danger" :disabled="disabled" @click="deleteOneFile(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <unit-select ref="unitSelect" @select="unitSelect"/>
    <vehicle-select ref="vehicleSelect" @select="vehicleSelect"/>
  </el-dialog>
</template>

<script>
  import UnitSelect from "@/views/information/Unit/UnitSelect";
  import MaterialTypeSelector from "./MaterialTypeSelector";
  import VehicleSelect from "@/views/information/Vehicle/VehicleSelect";
  import VmUploadFile from "@/components/VmUploadFile";
  import DownLoadFile from "@/components/DownLoadFile";
  const ossUrl = ".oss-cn-shanghai.aliyuncs.com";
  export default {
    components: {
      UnitSelect,
      MaterialTypeSelector,
      VehicleSelect,
      DownLoadFile,
      VmUploadFile,
    },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        authIndex: this.$route.meta.authIndex,
        imgUrls: [],
        uploadImg: {
          pictureUrl: "",
          pictureName: "",
        },
        limits: {
          uploadAuth: this.$auth(72),
        },
        materials: {
          pkId: 0,
          materialTypeName: "",
          materialTypeId: "",
          materialNO: "",
          materialName: "",
          mrpController: "",
          specification: "",
          productDistribution: "",
          netWeight: "",
          grossWeight: "",
          procurementType: "",
          productLayer: "",
          zmyxh: "",
          mrpType: "",
          feedingType: "",
          outerNO: "",
          labelNo: "",
          unitName: "",
          measuringUnitID: "",
          mlength: "",
          mwidth: "",
          mheight: "",
          mnetWeight: "",
          is_CHECK_SUB_RTN_MTRL: 0,
          is_CHECK_RETURN_MTRL: 0,
          is_CHECK_DELIVERY: 0,
          is_CHECK_RETURN: 0,
          is_CHECK_STOCK: 0,
          is_CHECK_PRODUCT: 0,
          is_CHECK_INCOMING: 0,
          is_KF_PERIOD: 0,
          is_SN_MANAGE: 0,
          is_BATCH_MANAGE: 0,
          materialVehicleIds: [],
          needSerialNo: true,
          accessoryList:[],
          deliverySerialNo:false,
          marketingLevel: "",
          delistStatus: "",
          standardDeliveryTime: "",
        },
        ruleValidate: {
          materialName: {required: true, message: "请输入物料名称", trigger: "blur"},
          mrpType: {required: true, message: "请选择Mrp类型", trigger: "change"},
          materialTypeName: {required: true, message: "请选择物料类型", trigger: "change"},
          feedingType: {required: true, message: "请选择投料类型", trigger: "change"},
          unitName: {required: true, message: "请选择物料单位", trigger: "change"},
        },
        tableData: [],
        columns: [
          {
            title: "载具编号",
            key: "vehicleNo",
            width: 100,
            align: "center",
          },
          {
            title: "载具名称",
            key: "vehicleName",
            minWidth: 140,
          },
          {
            title: "长度",
            key: "length",
            width: 90,
            align: "center",
          },
          {
            title: "宽度",
            key: "width",
            width: 90,
            align: "center",
          },
          {
            title: "限长",
            key: "lengthLimit",
            width: 90,
            align: "center",
          },
          {
            title: "限宽",
            key: "widthLimit",
            width: 90,
            align: "center",
          },
          {
            title: "载重",
            key: "load",
            width: 90,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        if (row) {
          const materialID = row.materialID || row.id;
          if (materialID) {
            this.getData(materialID);
          }
        }
      },

      selectMaterialType(row) {
        this.materials.materialTypeName = row.name;
        this.materials.materialTypeId = row.id;
      },

      unitSelect(row) {
        this.materials.unitName = row.unitName;
        this.materials.measuringUnitID = row.pkId;
      },

      vehicleSelect(row) {
        const arr = this.tableData.filter((item) => item.vehicleNo === row.vehicleNo);
        if (arr.length) {
          this.$confirm("该载具已存在,请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.tableData.push(row);
        }
      },

      getData(materialID) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sapBaseMaterials/${materialID}`)
          .then((resp) => {
            if (resp.success) {
              this.materials = resp.data;
              this.materials.pkId = resp.data.materialID;
              if (resp.data.materialVehicle != null) {
                this.tableData = resp.data.materialVehicle;
              }

              this.materials.accessoryList.forEach(row => {
                // 如果是阿里云的地址，则直接保留，不用重新查询下载接口
                if(row.filePath.includes(ossUrl)) {
                  row.imgUrl = row.filePath;
                  this.imgUrls.push(row.imgUrl);
                } else {
                  this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                    if (res.success) {
                      row.imgUrl = res.data;
                      this.imgUrls.push(row.imgUrl);
                    }
                  });

                }
              });

            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.materials.materialVehicleIds = this.tableData.map((item) => {
              return item.pkId;
            });
            this.submitLoading = true;
            this.$http
              .save("basic", "sapBaseMaterials", this.materials)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.materials.id) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      uploadSuccess(fileName) {
        if (fileName) {
          const params = {
            fileName: fileName,
            filePath: this.uploadImg.pictureUrl,
            itemID: this.materials.id,
          };
          this.$http.post("basic", "sapBaseMaterials/uploadImage", params)
            .then((resp) => {
              if (resp.success) {
                params.accessoryID = resp.data.accessoryID;
                this.$message.success("文件上传成功");
                this.materials.accessoryList.push({
                  ...params,
                  imgUrl: this.uploadImg.pictureUrl,
                  itemType: 16,
                });
                this.imgUrls.push(this.uploadImg.pictureUrl);
              }
            });
        }
      },

      deleteOneFile(index, row) {
        this.$http.delete("basic", "accessories", row.accessoryID)
          .then(() => {
            this.$message.success("删除成功");
            this.materials.accessoryList.splice(index, 1);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.materialEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 75%;
}

// 自适应模态框样式
.materialEdit .el-dialog__header {
  position: fixed;
  width: 1300px;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialEdit .el-dialog__footer {
  position: fixed;
  width: 1300px;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: auto;
}

.materialEdit .editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}

.materialEdit .el-form-item {
  width: 260px;
}

.materialEdit .el-form-item__content {
  width: 100%;
}

.materialEdit .el-input,
.materialEdit .el-select,
.materialEdit .el-input-number,
.materialEdit .el-textarea {
  width: 100%;
}
</style>




